var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-custom-query-logic" },
    [
      _c("DsfCustomQueryLogicTree", {
        attrs: {
          data: _vm.data,
          "show-data-type": _vm.showDataType,
          "drag-proxy-append-to": _vm.dragProxyAppendTo,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }